// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"365":"0fe7defa","614":"28743e7e","734":"ee7a4441"}[chunkId] + ".chunk.js";
};